import { useContext } from 'react';

import { MenuContext } from '../context/MenuContext';

export const useMenuContext = () => {
  const context = useContext(MenuContext);

  return context;
};
